export default __webpack_public_path__ + "media/7e10f11cf669007b9a9c0bdc3241675472ced6c38a1502941a857340cc3536d2.svg";